const state = {
  drawer: true,
  currentEmployee: {},
  authenticated: false,
}

const mutations = {
  DRAWER_TOGGLE() {
    state.drawer = !state.drawer
  },
}

const actions = {
  drawerToggle({ commit }) {
    commit('DRAWER_TOGGLE')
  },
}

const getters = {
  getDrawer() {
    return state.drawer
  },
  getCurrentEmployee() {
    return state.currentEmployee
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
